const ASSETS_URL = 'https://content.moneydesktop.com/storage/MD_Assets/md/cashflow'

export const CASHFLOW_IMAGES = {
  CASHFLOW_ONBOARDING: `${ASSETS_URL}/cashflow-onboarding.png`,
  CASHFLOW_LOADING_ANIMATION: `${ASSETS_URL}/loading-animation.gif`,
}
